import axios from './axios.jsx';

// Base URL matching your Spring Boot controller mapping
const API_BASE_URL = '/api/v1/courses';

const courseMasterService = {
  // Create course - POST /api/v1/courses/create
  createCourse: async (courseData) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/create`, courseData);
      return response.data;
    } catch (error) {
      console.error('Error creating course:', error);
      throw error;
    }
  },

  // Update course - PUT /api/v1/courses/update
  updateCourse: async (courseData) => {
    try {
      const response = await axios.put(`${API_BASE_URL}/update`, courseData);
      return response.data;
    } catch (error) {
      console.error('Error updating course:', error);
      throw error;
    }
  },

  // Delete course - DELETE /api/v1/courses/delete/{courseId}
  deleteCourse: async (courseId) => {
    try {
      const response = await axios.delete(`${API_BASE_URL}/delete/${courseId}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting course:', error);
      throw error;
    }
  },

  // Get course by ID - GET /api/v1/courses/{courseId}
  getCourseById: async (courseId) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/${courseId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching course:', error);
      throw error;
    }
  },

  // Get all courses - GET /api/v1/courses/all
  getAllCourses: async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/all`);
      return response.data;
    } catch (error) {
      console.error('Error fetching all courses:', error);
      throw error;
    }
  },

  // Get active courses only - GET /api/v1/courses/active
  getActiveCourses: async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/active`);
      return response.data;
    } catch (error) {
      console.error('Error fetching active courses:', error);
      throw error;
    }
  },

  // Get courses by category - GET /api/v1/courses/category/{category}
  getCoursesByCategory: async (category) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/category/${encodeURIComponent(category)}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching courses by category:', error);
      throw error;
    }
  },

  // Activate course - PUT /api/v1/courses/activate/{courseId}
  activateCourse: async (courseId) => {
    try {
      const response = await axios.put(`${API_BASE_URL}/activate/${courseId}`);
      return response.data;
    } catch (error) {
      console.error('Error activating course:', error);
      throw error;
    }
  },

  // Deactivate course - PUT /api/v1/courses/deactivate/{courseId}
  deactivateCourse: async (courseId) => {
    try {
      const response = await axios.put(`${API_BASE_URL}/deactivate/${courseId}`);
      return response.data;
    } catch (error) {
      console.error('Error deactivating course:', error);
      throw error;
    }
  },

  // Get total courses count - GET /api/v1/courses/count
  getTotalCoursesCount: async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/count`);
      return response.data;
    } catch (error) {
      console.error('Error fetching course count:', error);
      throw error;
    }
  },

  // Export all courses to Excel/PDF (using backend endpoints if available)
  exportCoursesToExcel: async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/export/excel`, {
        responseType: 'blob'
      });
      return response.data;
    } catch (error) {
      console.error('Error exporting to Excel:', error);
      throw error;
    }
  },

  exportCoursesToPDF: async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/export/pdf`, {
        responseType: 'blob'
      });
      return response.data;
    } catch (error) {
      console.error('Error exporting to PDF:', error);
      throw error;
    }
  }
};

export default courseMasterService;